import type { RegistrationAccountStatus } from '@/_constants/RegistrationAccountStatus.ts';
import { createContext, useContext } from 'react';

export interface Registration {
  name: string;
  last_name: string;
  email: string;
  password: string;
  repeat_password: string;
  terms: boolean;
}

export type RegistrationDraft = Omit<Registration, 'password' | 'repeat_password'>;

export interface RegistrationFlowContextValue {
  draftUser: RegistrationDraft | null;
  accountStatus: RegistrationAccountStatus;
  token: string | null;
  saveDraft(user: RegistrationDraft): void;
  setStatus(status: RegistrationAccountStatus): void;
  clearFlow(): void;
  setToken(token: string): void;
}

export const RegistrationFlowContext = createContext<RegistrationFlowContextValue | undefined>(undefined);

export function useRegistrationContext(): RegistrationFlowContextValue {
  const context = useContext(RegistrationFlowContext);

  if (!context) {
    throw new Error('useRegistrationContext should be called within RegistrationFlow.');
  }

  return context;
}
